import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RRule } from 'rrule';
import { CampaignModel } from 'src/app/models/campaign-model';
import { environment } from 'src/environments/environment';
import { ShareLinkDialogComponent } from '../dialogs/share-link-dialog/share-link-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ResponsiveBaseComponent } from '../responsive-base/responsive-base.component';

@Component({
    selector: 'app-campaign',
    templateUrl: './campaign.component.html',
    styleUrls: ['./campaign.component.scss'],
    standalone: false
})
export class CampaignComponent extends ResponsiveBaseComponent implements OnInit {
  @Input()
  public campaign: CampaignModel;

  @Output()
  public onDeletePressed = new EventEmitter();

  @Output()
  public onActivatePressed = new EventEmitter();

  @Output()
  public onReactivatePressed = new EventEmitter();

  @Output()
  public onDeactivatePressed = new EventEmitter();

  @Output()
  public onEditPressed = new EventEmitter();

  public recurrenceDisplayString: string;

  constructor(private readonly shareLinkDialog: MatDialog,
    responsive: BreakpointObserver,
  ) {
    super(responsive);
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.campaign?.recurrencePattern) {
      this.recurrenceDisplayString = new RRule(RRule.parseString(this.campaign.recurrencePattern)).toText();
    }
    else {
      this.recurrenceDisplayString = 'Does not repeat';
    }
  }

  public edit(): void {
    this.onEditPressed.emit(null);
  }

  public delete(): void {
    this.onDeletePressed.emit(null);
  }

  public canShowActivateAction(): boolean {
    const result = this.campaign?.isInactive();
    return result;
  }

  public canShowReactivateAction(): boolean {
    const result = this.campaign?.isExpired() || this.campaign?.isArchived();
    return result;
  }

  public canShowArchiveAction(): boolean {
    const result = this.campaign?.isActive() || this.campaign?.isPendingActivation();
    return result;
  }

  public canShowEditAction(): boolean {
    const result = this.campaign?.isActive() || this.campaign?.isPendingActivation();
    return result;
  }

  public canShowShareAction(): boolean {
    const result = this.campaign?.isActive();
    return result;
  }

  public activate(): void {
    this.onActivatePressed.emit(null);
  }

  public reactivate(): void {
    this.onReactivatePressed.emit(null);
  }

  public share(): void {
    this.shareLinkDialog.open(ShareLinkDialogComponent, {
      data: {
        title: "Share This",
        message: "Share this stamp card on your social media",
        data: this.getCampaignLink()
      }
    });
  }

  public getCampaignLink() : string {
    return environment.storefrontUrl + "/stamp-cards/" + this.campaign.id;
  }
}
